import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

export default function GoogleSignInButton({ onSuccess, onError }) {
  const { googleSignIn } = useAuth();
  const { isDarkMode } = useTheme();

  const handleGoogleSuccess = async (credentialResponse) => {
    const { credential } = credentialResponse;

    if (!credential) {
      console.error('Google sign-in: no credential in response', Object.keys(credentialResponse || {}));
      if (onError) {
        onError('Google sign-in did not return a credential. Please try again.');
      }
      return;
    }

    const result = await googleSignIn(credential);
    if (!result.ok) {
      console.error('Google sign-in error:', result.error);
      if (onError) {
        onError(result.error || 'Google sign-in failed. Please try again.');
      }
      return;
    }

    if (onSuccess) {
      onSuccess(result);
    }
  };

  const handleGoogleError = () => {
    console.error('Google sign-in popup was cancelled or failed.');
    if (onError) {
      onError('Google sign-in was cancelled or failed. Please try again.');
    }
  };

  return (
    <div className="google-signin-wrapper">
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        theme={isDarkMode ? 'filled_black' : 'outline'}
        size="large"
        text="signin_with"
        use_fedcm_for_prompt
      />
    </div>
  );
}
